export default __webpack_public_path__ + "static/media/teaser_2_thumb.1a504b9b.png";